'use client';

import Link from 'next/link';
import { useParams } from 'next/navigation';

import Container from '@/components/ui/Container';
import Text from '@/components/ui/Text';
import { normalizeLocale } from '@/lib/i18n/contactFormI18n';
import { COPYRIGHT_I18N } from '@/lib/i18n/copyright';

const Copyright = ({ firmName }: CopyrightProps) => {
  const currentYear = new Date().getFullYear();
  const { locale: rawLocale } = useParams<{ locale: string }>();
  const locale = normalizeLocale(rawLocale);
  const { copy } = COPYRIGHT_I18N[locale];

  return (
    <Container className="py-0! flex flex-col tablet:flex-row items-center justify-between gap-2">
      <Text as="span" variant="copyright">
        © {currentYear} {firmName}
      </Text>
      <Text as="span" variant="copyright" className="flex items-center gap-1.5">
        {copy}
        <Link
          href="https://include.agency"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 text-white/60 hover:text-white transition-colors duration-200"
        >
          <span className="text-secondary" aria-hidden="true">
            ✦
          </span>
          Include
        </Link>
      </Text>
    </Container>
  );
};

export default Copyright;

type CopyrightProps = {
  firmName: string;
};
